import { deleteRequest, get, post,} from "services/BaseClient/Client"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";
import { CreateUrlFilter } from "helpers/CreateURLFilter";

export const  getMLSStoreFilter= async (filter:any): Promise<DataResponse<any>> => {
    const query = filter?CreateUrlFilter(filter):null
    const url = `${endpoints.getMLSStoreFilter}?${query}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  export const  getMyPortfolioAdverts= async (filter:any): Promise<DataResponse<any>> => {
    const query = filter?CreateUrlFilter(filter):null
    const url = `${endpoints.getMyPortfolioAdverts}?${query}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  export const  getMLSPotentialAdverts= async (filter:any): Promise<DataResponse<any>> => {
    const query = filter?CreateUrlFilter(filter):null
    const url = `${endpoints.getPotentialAdverts}?${query}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  export const  getIncomingMLSRequst= async (filter:any): Promise<DataResponse<any>> => {
    const query = filter?CreateUrlFilter(filter):null
    const url = `${endpoints.getIncomingMLSRequst}?${query}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };
  export const  getOutcomingMLSRequst= async (filter:any): Promise<DataResponse<any>> => {
    const query = filter?CreateUrlFilter(filter):null
    const url = `${endpoints.getOutcomingMLSRequst}?${query}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };
  export const  acceptMLSRequest= async (requestId:string): Promise<DataResponse<any>> => {
    const url = `${endpoints.acceptMLSRequest}/${requestId}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, {},config);
  };
  export const  rejectMLSRequest= async (requestId:string): Promise<DataResponse<any>> => {
    const url = `${endpoints.recetMLSRequest}/${requestId}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url,{}, config);
  };
  export const  sendMLSRequest= async (data:any): Promise<DataResponse<any>> => {
  
    const url = `${endpoints.sendMLSRequest}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, data,config);
  };

  export const  removeMLS= async (advert:any): Promise<DataResponse<any>> => {
 
    const url = `${endpoints.removeMls}/${advert.id}`;
    const config = headers.content_type.application_json;
    return deleteRequest<DataResponse<any>>(url, {},config);
  };